import Animation from './Animation';
import './Dialog.css';

export default class Dialog extends Animation {

	constructor (master, entity, dialog) {

		super(master, 0);
		this.entity = entity;
		this.dialog = dialog;
		//this.loadAudio("draw");
	}

	run () {

		setTimeout(() => {
			var el;
			if (this.entity.key !== undefined && this.entity.key !== null)
				el = document.querySelector("#game-entity-" + this.entity.key + ".game-entity-" + this.entity.name + " .game-entity-dialog");
			else
				el = document.querySelector("#game-entity-" + this.entity + " .game-entity-dialog");
			if (el && !el.classList.contains("dialog-anim")) {
				el.classList.add("dialog-anim");
				el.textContent = this.dialog;
				setTimeout(() => el.classList.remove("dialog-anim"), 6000);
			}
		}, 300);
	}
}